var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"audio-page",attrs:{"id":_vm.id}},[_c('div',{staticClass:"audio-module-wrap"},[_c('div',{staticClass:"audio-module"},[_c('img',{attrs:{"src":_vm.post.acf.audio_image}}),_c('AudioPlayer',{attrs:{"sources":_vm.audioSources}})],1)]),_c('PageDescription',{attrs:{"post":_vm.post}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }